import axios from 'axios';

const api = {
  async fetchTwilioAccessToken() {
    const response = await axios.get(`/twilio/generate_access_token`);
    return response.data;
  },
};

export default api;
